export const formItemRequiredRule = {
  required: true,
  message: `Required`,
};
